import { DataBinding } from '@se/se.ui.html5';

export const HardcodedData = {
    bindings: {
        report: new DataBinding('Report'),
        idModelTypeRootList: new DataBinding('Report.IdModelTypeRootList'),
        // Fixed
        examinations: new DataBinding('Report.Examinations'),
        addendums: new DataBinding('Report.Addendums'),
        pacsTuple: new DataBinding('Report.Examinations.NplaPacs'),
        referenceExamination: new DataBinding('Report.ReferenceExamination'),
        isDigitallySigned: new DataBinding('Report.ReferenceExamination.IsDigitallySigned'),
        referringPhysician: new DataBinding('Report.ReferenceExamination.IdReferringPhysician'),
        businessUnit: new DataBinding('Report.ReferenceExamination.IdBusinessUnit'),
        provenance: new DataBinding('Report.ReferenceExamination.IdProvenance'),
        patient: new DataBinding('Report.Patient'),
        BSA: new DataBinding('Report.ReferenceExamination.Bsa'),
        BMI: new DataBinding('Report.ReferenceExamination.Bmi'),
        patientHeight: new DataBinding('Report.ReferenceExamination.HeightFomula'),
        patientWeight: new DataBinding('Report.ReferenceExamination.Weight'),
        hardCodedData: new DataBinding('Report.HardCodedData'),
        // Common
        examId: new DataBinding('Report.ReferenceExamination.IdExam.Id'),
        exam: new DataBinding('Report.JSonData.Exam'),
        keyImages: new DataBinding('Report.JSonData.Exam.KeyImages'),
        imagePerRowInPlaceholder: new DataBinding('Report.JSonData.Exam.ImagePerRowInPlaceholder'),

        // Utility
        detail: new DataBinding('Detail'),
        patientSimple: new DataBinding('Patient'),
        study: new DataBinding('Study'),
        // Modules
        ecoCv: {
            report: new DataBinding('Report.EcoCVReport.0'),
            anatomicDistricts: new DataBinding('Report.EcoCVReport.JSonData.AnatomicDistrict'),
            clinicalEvaluations: new DataBinding('Report.EcoCVReport.JSonData.ClinicalEvaluation'),
            clinicalEvaluationsCombo: new DataBinding(
                'Report.EcoCVReport.JSonData.ClinicalEvaluation.ClinicalEvaluationCombo',
            ),
            clinicalEvaluationsComboIndexed: new DataBinding(
                'Report.EcoCVReport.0.JSonData.ClinicalEvaluation.ClinicalEvaluationCombo',
            ),
            clinicalEvaluationsMultiCombo: new DataBinding(
                'Report.EcoCVReport.JSonData.ClinicalEvaluation.ClinicalEvaluationMultiCombo',
            ),
            clinicalEvaluationsMulitComboIndexed: new DataBinding(
                'Report.EcoCVReport.0.JSonData.ClinicalEvaluation.ClinicalEvaluationMultiCombo',
            ),
            clinicalEvaluationsString: new DataBinding(
                'Report.EcoCVReport.JSonData.ClinicalEvaluation.ClinicalEvaluationString',
            ),
            clinicalEvaluationsFlag: new DataBinding(
                'Report.EcoCVReport.JSonData.ClinicalEvaluation.ClinicalEvaluationFlag',
            ),
            lvKinetic: new DataBinding('Report.EcoCVReport.JSonData.Kinetic.LVKinetic'),
            measuresIndexed: new DataBinding('Report.EcoCVReport.0.JSonData.Measure'),
            measureSource: new DataBinding('Report.EcoCVReport.JSonData.MeasureSource'),
            measureZScore: new DataBinding('Report.EcoCVReport.JSonData.Measure'),
            measures: new DataBinding('Report.EcoCVReport.JSonData.Measure'),
        },
    },

    lists: {
        measureSiteList: 'lsUsMeasureSite',
        clinicalEvaluationFlagList: 'lsUsClinicalEvaluationFlag',
        clinicalEvaluationStringList: 'lsUsClinicalEvaluationString',
        clinicalEvaluationComboList: 'lsUsClinicalEvaluationCombo',
        leftVentricleSegmentList: 'lsLeftVentricleSegment',
        leftVentricleKineticList: 'lsLeftVentricleKinetic',
    },

    idUsMeasureCalculations: {
        mean: 'c85a3347-48de-4d87-93c6-e8f2bbe1816d',
        median: '72017896-2102-4b10-b733-01e777f82cf2',
        mode: '29d9d7ed-ee6d-4d5f-be97-faedbb800144',
        max: '23566a57-d0e1-4296-a815-6dbbc6edc7ad',
        min: 'ef4502a6-af5d-4826-9f0f-50eb647f1942',
        last: '4f94abf5-96e7-4f87-bd01-3330e246226c',
    } as const,

    idCardioWebServiceForExtUrlToken: '75C8C7C7-12F8-40F3-B5A5-57513658B243',

    sportMedicineCustomPageRoot: 'e735de2c-3101-4045-8a5c-f12b39a52e96',

    measureNormalValueConstraintMin: '9d9459fe-244a-4a1d-a1be-1be13f16b172',
    measureNormalValueConstraintMax: 'd1d178b9-1e5d-40f8-984c-e43196d169f2',
    measureSourceCalculated: 'c01798ad-d943-4c93-adf6-895fd3b5c1ed',

    idUS2AIMeasureSource: '568e4de0-79c5-4a92-a940-fcac1683254c',
    idLeftVentricleSite: 'd4654bb9-e918-4af4-bce6-c1b2d30074fe',
    idNotEvaluatedLeftVentricleKinetic: '9e6ca691-31f5-4bd9-95ec-0c6d2e87650f',
};

export type IdUsMeasureCalculations = (typeof HardcodedData)['idUsMeasureCalculations'];
export type IdUsMeasureCalculationType = IdUsMeasureCalculations[keyof IdUsMeasureCalculations];

export interface MeasureHistoryItem {
    date: Date;
    value: number;
    unitOfMeasure: string;
}
